<template>
<v-container align-center>
  <v-flex xs12 sm6 offset-sm3 text-xs-center class="about-logo-center">
            <v-flex xs2>
              <img src="/static/logo-about.png"  class="slashdr--logo">
            </v-flex>
            <ul>
              <li>Web App: {{webAppVersion}}</li>
            </ul>

  </v-flex>
</v-container>

</template>

<script>
import $ from 'jquery';
import { mapState } from 'vuex';
import { api } from '../api.js';
import { axios, get } from 'axios';

export default {
  name: 'About',
  components: {},
  data() {
    return {
      version: ''
    };
  },
  mounted() {
    this.getVersion();
  },
  computed: {
    webAppVersion: () => {
      return process.env.VERSION;
    }
  },

  methods: {
    getVersion() {
      get(api + `/version`).then(res => {
        console.log(res);
        this.apiVersion = res.data.latest_version;
      });
    }
  },
};
</script>
<style scoped>
.about-logo-center {
  height: calc(100vh - 88px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.about-logo-center .flex {
  flex: initial;
  margin-bottom: 20px;
}
.about-logo-center {
  font-size: 18px;
  font-weight: 800;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue